import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import Swal from 'sweetalert2';
import { MemberProfileMail } from '../models/member-profile-mail.model';
import { Memberprofile } from '../models/memberprofile.model';
import { CrudService } from '../service/crud.service';
import { ProfileService } from '../service/profile.service';
import { SharedService } from '../service/shared.service';


@Component({
  selector: 'app-membernewjoiner',
  templateUrl: './membernewjoiner.component.html',
  styleUrls: ['./membernewjoiner.component.css']

})
export class MembernewjoinerComponent implements OnInit {

  _ProfileModel: Memberprofile = new Memberprofile();

  ProfileMailList: MemberProfileMail[] = [];
  TempProfileList: any[] = [];
  ProfileMailModel: MemberProfileMail = new MemberProfileMail();
  _ProfileMailModel: MemberProfileMail = new MemberProfileMail();
  _ProfileMailList: MemberProfileMail[] = [];
  CheckCount = 0;
  UserId: any = sessionStorage.getItem("userId");
  url: any = '';
  msg = "";
  filesToUpload: any[] = [];
  FileUpload: any = [];
  files: any[] = [];
  RecordID: any;
  DisableSubmitButton: boolean = false;

  Editorconfig: AngularEditorConfig = {
    // editable: true,
    // spellcheck: true,

    // height: '16rem',
    // minHeight: '5rem',
    // placeholder: 'Enter text here...',
    // translate: 'no',
    // defaultParagraphSeparator: 'p',
    // defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      [
        'subscript',
        'strikeThrough',
        'superscript',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode',
        'insertUnorderedList',
        'insertOrderedList'

      ]
    ],

    editable: true,
    spellcheck: true,
    height: "5rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    sanitize: false
  };

  constructor(private _profileser: ProfileService, private route: ActivatedRoute, public _SharedSer: SharedService, private router: Router, private _crudSer: CrudService) { }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      this.RecordID = atob(params['p']);
      this.ViewProfile(this.RecordID);
      // this.getProfileDetails();

    });

  }



  ViewProfile(RecordID: string) {

    this._profileser.GetProfileDetailsByProfileId(RecordID).subscribe(
      data => {
        console.log(data);
        if (data.Status) {
          this._ProfileModel = data.Data;
          this._ProfileMailModel.MEMBER_NAME = data.Data.MEMBER_NAME;
          this._ProfileMailModel.MEMBER_DESIGNATION = data.Data.MEMBER_DESIGNATION;
        }
        this.GetAllPIDocuments(this._ProfileModel.MEMBER_TMC);
        this.getProfileDetails();
      },
      error => { console.error(error); }
    );
  }

  GetAllPIDocuments(DocumentNo: string) {
    this._profileser.GetAllDocuments(DocumentNo).subscribe(
      data => {
        if (data.indexOf('Could not find a part of the path') <= -1) {
          this.files = [];
          this.url = this._crudSer.profilesiteUrl + "PROFILEIMAGE/" + DocumentNo + "/" + data[0];
          data.forEach((element: any) => {
            this.files.push({ name: element, DownloadFlag: true })
          });
        }
        else {
          this.url = null;
        }
        console.log(this.url);
      }, error => console.error());
  }

  validate() {
    if (this._SharedSer.checkProperty(this._ProfileMailModel.MESSAGE1)) {
      Swal.fire({
        toast: true,
        title: 'Enter Message 1',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })
      return true;
    }
    else if (this._SharedSer.checkProperty(this._ProfileMailModel.MESSAGE2)) {

      Swal.fire({
        toast: true,
        title: 'Enter Message 2',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,

        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      return true;
    }
    else if (this._SharedSer.checkProperty(this._ProfileMailModel.MESSAGE3)) {

      Swal.fire({
        toast: true,
        title: 'Enter Message 3',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,

        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      return true;
    }
    else if (this._SharedSer.checkProperty(this._ProfileMailModel.MESSAGE4)) {
      Swal.fire({
        toast: true,
        title: 'Enter Message 4',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })
      return true;
    }
    else if (this._SharedSer.checkProperty(this._ProfileMailModel.MESSAGE5)) {

      Swal.fire({
        toast: true,
        title: 'Enter Message 5',
        icon: 'error',
        position: 'top',
        width: 350,
        timer: 4000,
        showConfirmButton: false,
        timerProgressBar: true,

        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      return true;
    }
    else {
      return false;
    }
  }


  SaveProfileData() {
    if (this.validate()) {
      return;
    }

    this.DisableSubmitButton = true;
    let formdata = new FormData();

    this._ProfileMailModel.MESSAGE_CREATED_BY = sessionStorage.getItem('userId');
    this._ProfileMailModel.MESSAGE_SUBMISSION_BY = sessionStorage.getItem('userId');
    this._ProfileMailModel.PROFILE_ID = this.RecordID;
    this._ProfileMailModel.MODIFIED_BY = sessionStorage.getItem('userId');

    formdata.append("MemberMailDetails", JSON.stringify(this._ProfileMailModel));
    this._profileser.SaveMailDetails(formdata).subscribe(
      data => {
        if (data.Status) {
          Swal.fire({
            toast: true,
            title: 'Profile Data updated successfully',
            icon: 'success',
            position: 'top',
            width: 350,
            timer: 4000,
            showConfirmButton: false,
            timerProgressBar: true,

            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })
          //this.getProfileDetails(); 
        }
        else {
          //Swal.fire(data.Message); 

          Swal.fire({
            toast: true,
            title: data.Message,
            icon: 'error',
            position: 'center',
            width: 350,
            timer: 4000,
            showConfirmButton: false,
            timerProgressBar: true,

            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })
          this.DisableSubmitButton = false;

        }
      }, error => console.error());
  }


  getProfileDetails() {

    this._profileser.GetProfileMailDetailsById(this._ProfileModel.MEMBER_TMC).subscribe(
      data => {
        // debugger;
        if (data.Status) {
          if (data.Data != null) {
            this._ProfileMailModel = data.Data;

          }
        }
      }, error => console.error());
  }

}
